import React, { useState, useEffect } from "react";

import { Link, useLocation } from "react-router-dom";
import { Icon, Container } from "rbx";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import ClickCapture from "../ClickCapture";

import "./Sidebar.scss";

import NestedMenu from "./NestedMenu";

import routes from "./routes";

import UserActionsDropdown from "../UserActionsDropdown";

import { useCurrentUserRoles } from "../Authorization";

import UserActionButton from "./UserActionButton";

const { REACT_APP_REPORT_BASE_URL } = process.env;

const isStage =
  REACT_APP_REPORT_BASE_URL === "https://transgas.gravoccloud.com:444";
function Sidebar() {
  const roles = useCurrentUserRoles();

  const location = useLocation();
  const [menuActive, setMenuActive] = useState(false);
  const [activeMenus, setActiveMenus] = useState({});
  const [activeRoute, setActiveRoutes] = useState({});

  useEffect(() => {
    setMenuActive(false);
  }, [location.pathname]);

  const toggleActiveMenus = name =>
    setActiveMenus({ ...activeMenus, [name]: !activeMenus[name] });

  // close sidebar menu when ESC key is pressed
  useEffect(() => {
    const handleKeyDown = e => {
      if (menuActive && e.keyCode === 27) {
        setMenuActive(false);
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  });

  const availableRoutes = routes.filter(route =>
    route.permissions.some(perm => roles.some(x => perm === x))
  );

  const toggleActiveRoutes = id => {
    setActiveRoutes(availableRoutes[id]);
    setMenuActive(true);
  };

  return (
    <nav className="navigation-bar">
      <ClickCapture onOutsideClick={() => setMenuActive(false)}>
        <Container fluid>
          <div className="navigation">
            <div className="navigation-start">
              <div className="navigation-item">
                <NestedMenu
                  activeMenus={activeMenus}
                  isActive={menuActive}
                  links={activeRoute.links}
                  name={activeRoute.name}
                  toggleMenus={toggleActiveMenus}
                />
              </div>
              <Link className="navigation-item navigation-item--brand" to="/">
                TransMission
              </Link>
            </div>
            <div className="navigation-end">
              <div className="navigation-item">
                <UserActionsDropdown />
              </div>
            </div>
          </div>
        </Container>
        <div
          className="sidebar"
          // style={isStage ? { background: "hsl(348, 100%, 61%)" } : {}}
        >
          <div className="sidebar-container">
            <div className="sidebar-menu">
              <Link className="sidebar-menu-item" to="/">
                <Icon size="large">
                  <FontAwesomeIcon icon="home" />
                </Icon>
                <span>Home</span>
              </Link>
              {availableRoutes.map((r, i) => (
                <div
                  className={`sidebar-menu-item ${
                    activeRoute === availableRoutes[i] && menuActive
                      ? "is-active"
                      : ""
                  } ${r.active?.(location) ? "is-current" : ""}`}
                  key={i}
                  role="button"
                  tabIndex="0"
                  onClick={() => toggleActiveRoutes(i)}
                  onKeyDown={() => toggleActiveRoutes(i)}
                >
                  <Icon size="large">
                    <FontAwesomeIcon icon={r.icon} />
                  </Icon>
                  <span>{r.label}</span>
                </div>
              ))}
              <UserActionButton />
            </div>
            {/* <div className="sidebar-drawer">
            <div className="sidebar-drawer-toggle">
              <div className="arrow-right" />
            </div>
          </div> */}
          </div>
        </div>
      </ClickCapture>
    </nav>
  );
}

Sidebar.propTypes = {};

export default Sidebar;
